import React from "react";
import { useQuery } from "react-query";
import { getOauthHandleForReminder } from "./gateway";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import DangerouslySetHtmlContent from "dangerously-set-html-content";
import { useTranslation } from "react-i18next";

export default function useOAuthForReminder(
  mode: string,
  token: string,
  oauthVerifier: string,
) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useQuery({
    queryFn: () => getOauthHandleForReminder(mode, token, oauthVerifier),
    queryKey: "handle-ggsis-reminder",
    onSuccess: (data) => {
      navigate("/welcome/resetPasswordForm", {
        state: {
          m01Id: data.data.m01Id,
          m01UserName: data.data.m01UserName,
        },
      });
    },
    onError: (error: AxiosError<string>) => {
      enqueueSnackbar(
        <div>
          {error.response?.data ? (
            <DangerouslySetHtmlContent html={error.response?.data} />
          ) : (
            t(
              "Συνέβη κάποιο σφάλμα συστήματος, παρακαλούμε προσπαθήστε ξανά αργότερα.",
            )
          )}
        </div>,
        { variant: "error" },
      );
      navigate("/welcome/reminderForm");
    },
    retry: false,
    cacheTime: 0,
  });
}
